<template>
  <!-- 固定定位在底部的菜单栏 -->
  <div>
    <welcome  ref="welcomeRef"></welcome>
    <nav class="tab-bar">
      <div v-for="(item, index) in tabs" :key="index" class="tab-item" :class="{ active: $route.name === item.routeName }" @click="navigateTo(index)">
        <span>{{ item.text }}</span>
      </div>
    </nav>
  </div>
</template>

<script>
import welcome from './welcome.vue'

export default {
  components: {
    welcome: welcome
  },
  data() {
    return {
      tabs: [
        { text: '抢单大厅', icon: 'icon-home', routeName: '/mobWelcome' },
        { text: '服务单', icon: 'icon-message', routeName: '/mobMy' },
        { text: '我的', icon: 'icon-user', routeName: '/mobMine' }
      ],
      pageType: 0 
    }
  },
  methods: {
    navigateTo(item) {
      this.$refs.welcomeRef.setPage(item)
    }
  }
}
</script>
<style scoped>
.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  display: flex;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}
.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 12px;
}
.tab-item.active {
  color: #42b983; /* 激活态颜色 */
}
.tab-item i {
  font-size: 20px;
  margin-bottom: 3px;
}
</style>
